import { Inject, Injectable } from '@angular/core';
import { FEATURE_FLAGS } from './feature-flag.providers';
import { FeatureFlag } from './feature-flag.interface';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class FeatureFlagsService {
  features: FeatureFlag;

  constructor(@Inject(FEATURE_FLAGS) private _features: FeatureFlag[]) {
    this.features = _features.reduce(
      (acc: FeatureFlag, current: FeatureFlag) => {
        return {
          ...current,
          ...acc,
        };
      },
      {} as FeatureFlag,
    );
  }

  loadFeatureFlags(): Observable<FeatureFlag> {
    return of(this.features);
  }

  isFeatureFlagEnabled(featureFlag: string): boolean {
    return this.features[featureFlag] || false;
  }
}
